import Page from "../Common/Page";
import { http } from "../Common/http";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { Messages } from "../Common/ValidateMessages";
import { AuthContext } from "../Auth/Auth";
import React from "react";
import { Form, Input, Row, Col, Select, Button, message } from "antd";
import {
  userTypeCodeODK_SU,
  userTypeCodeUNIV_SU,
  userTypeCodeUNIV_HEAD,
  userTypeCodeUNIV_GRADER,
  userTypeNameUNIV_SU,
} from "../Common/AppSettings";
import { NavigateFunction, Params } from "react-router-dom";
import withRouterDom from "../Common/WithReactRouterDom";
import { ResultBean } from "../Common/Utils";

const { Option } = Select;

type FormData = {
  universityCode: string;
  userAccount: string;
  mailAddress: string;
  sei: string;
  mei: string;
  seiKana: string;
  meiKana: string;
  userTypeCode: string;
  disabledFlag: string;
  browsePastFlag: string;
  superUpdateFlag: string;
  facultyId: string;
  departmentId: string;
  majorId: string;
  courceId: string;
};
interface Props {
  navigation: NavigateFunction;
  params: Readonly<Params<string>>;
  location: any;
}
interface UserGetRequestBean {
  userId: string;
}
interface UserGetResponseBean {
  userId: string;
  universityCode: string;
  userAccount: string;
  mailAddress: string;
  sei: string;
  mei: string;
  seiKana: string;
  meiKana: string;
  userTypeCode: string;
  disabledFlag: string;
  browsePastFlag: string;
  superUpdateFlag: string;
  facultyId: string | undefined;
  departmentId: string | undefined;
  majorId: string | undefined;
  courceId: string | undefined;
  updatedByUserId: string;
  userTypeName: undefined;
  facultyName: undefined | undefined;
  departmentName: undefined | undefined;
  majorName: undefined | undefined;
  courceName: undefined | undefined;
}
interface UserSaveRequestBean {
  userId: string | undefined;
  universityCode: string;
  userAccount: string;
  mailAddress: string;
  sei: string;
  mei: string;
  seiKana: string;
  meiKana: string;
  userTypeCode: string;
  disabledFlag: string;
  browsePastFlag: string;
  superUpdateFlag: string;
  facultyId: string | undefined;
  departmentId: string | undefined;
  majorId: string | undefined;
  courceId: string | undefined;
}
interface UserCheckAccountRequestBean {
  userId: string | undefined;
  userAccount: string;
  universityCode: string | undefined;
}
interface UserCheckMailAddressRequestBean {
  userId: string | undefined;
  mailAddress: string;
}

class UserRegister extends React.Component<Props> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  state = {
    // errorMsg: "",
    showDivId: 1,
    showFaculty: 0,
    userTypeSelectDiv: undefined,

    userId: undefined,
    universityCode: undefined,
    userAccount: undefined,
    mailAddress: undefined,
    sei: undefined,
    mei: undefined,
    seiKana: undefined,
    meiKana: undefined,
    userTypeCode: undefined,
    userTypeName: undefined,
    disabledFlag: undefined,
    browsePastFlag: undefined,
    superUpdateFlag: undefined,
    facultyId: undefined,
    facultyName: undefined,
    departmentId: undefined,
    departmentName: undefined,
    majorId: undefined,
    majorName: undefined,
    courceId: undefined,
    courceName: undefined,
  };

  constructor(props: Props) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
  }

  setUserDataToState(data: any) {
    this.setState({
      userId: data.userId,
      universityCode:
        this.context.user.userTypeCode === userTypeCodeODK_SU
          ? data.universityCode
          : this.context.user.universityCode,
      mailAddress: data.mailAddress,
      userAccount: data.userAccount,
      disabledFlag: data.disabledFlag,
      browsePastFlag: data.browsePastFlag,
      superUpdateFlag: data.superUpdateFlag,
      sei: data.sei,
      mei: data.mei,
      seiKana: data.seiKana,
      meiKana: data.meiKana,
      userTypeCode: data.userTypeCode,
      userTypeName: data.userTypeName,
    });
    if (
      this.state.userTypeCode === userTypeCodeUNIV_HEAD ||
      this.state.userTypeCode === userTypeCodeUNIV_GRADER
    ) {
      this.setState({
        showFaculty: 1,
        facultyId: data.facultyId,
        departmentId: data.departmentId,
        majorId: data.majorId,
        courceId: data.courceId,
        facultyName: data.facultyName,
        departmentName: data.departmentName,
        majorName: data.majorName,
        courceName: data.courceName,
      });
    }
  }
  setUserStateDataToForm() {
    this._form.current.setFieldsValue({
      universityCode: this.state.universityCode,
      mailAddress: this.state.mailAddress,
      userAccount: this.state.userAccount,
      disabledFlag: this.state.disabledFlag,
      browsePastFlag: this.state.browsePastFlag,
      superUpdateFlag: this.state.superUpdateFlag,
      sei: this.state.sei,
      mei: this.state.mei,
      seiKana: this.state.seiKana,
      meiKana: this.state.meiKana,
      userTypeCode: this.state.userTypeCode,
    });
    if (
      this.state.userTypeCode === userTypeCodeUNIV_HEAD ||
      this.state.userTypeCode === userTypeCodeUNIV_GRADER
    ) {
      this._form.current.setFieldsValue({
        facultyId: this.state.facultyId,
        departmentId: this.state.departmentId,
        majorId: this.state.majorId,
        courceId: this.state.courceId,
      });
    }
  }

  componentDidMount = async () => {
    const { params } = this.props;
    if (this.context.user.userTypeCode === userTypeCodeODK_SU) {
      this.setState({
        userTypeSelectDiv: "1",
        userTypeCode: userTypeCodeUNIV_SU,
        userTypeName: userTypeNameUNIV_SU,
      });
    } else {
      this.setState({
        universityCode: this.context.user.universityCode,
        userTypeSelectDiv: "0",
      });
    }
    if (params.userId !== undefined) {
      // 修正の場合
      try {
        this._page.current?.setState({ isPageLoading: true });
        // this.setState({ errorMsg: "" });

        // backend通信し、ユーザ登録
        const postData: UserGetRequestBean = {
          userId: params.userId,
        };
        const result = await http<UserGetResponseBean, UserGetRequestBean>({
          path: "/User/get",
          method: "post",
          body: postData,
          accessToken: this.context.accessToken,
        });
        if (result.ok) {
          this.setUserDataToState(result.body);
          this.setUserStateDataToForm();
        } else {
          message.error(Messages["ERR-020"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        console.log(error);
        message.error(Messages["ERR-020"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    }
  };

  // 登録画面の選択項目変更
  onChangeUniversityCode = (newValue: any) => {
    this.setState({
      universityCode: newValue !== undefined ? newValue.value : undefined,
    });
  };
  onChangeUserTypeCode = (newValue: any) => {
    const showFaculty =
      newValue.value === userTypeCodeUNIV_HEAD ||
      newValue.value === userTypeCodeUNIV_GRADER
        ? 1
        : 0;
    this.setState({
      userTypeCode: newValue !== undefined ? newValue.value : undefined,
      userTypeName: newValue !== undefined ? newValue.label : undefined,
      showFaculty: showFaculty,
    });

    if (showFaculty === 1) {
      this.setState({
        universityCode: this.state.universityCode,
      });
    } else {
      this.setState({
        facultyId: undefined,
        facultyName: undefined,
        departmentId: undefined,
        departmentName: undefined,
        majorId: undefined,
        majorName: undefined,
        courceId: undefined,
        courceName: undefined,
      });
    }
  };
  onChangeFacultyId = (newValue: any) => {
    this.setState({
      facultyId: newValue !== undefined ? newValue.value : undefined,
      facultyName: newValue !== undefined ? newValue.label : undefined,
      departmentId: undefined,
      departmentName: undefined,
      majorId: undefined,
      majorName: undefined,
      courceId: undefined,
      courceName: undefined,
    });
  };
  onChangeDepartmentId = (newValue: any) => {
    this.setState({
      departmentId: newValue !== undefined ? newValue.value : undefined,
      departmentName: newValue !== undefined ? newValue.label : undefined,
      majorId: undefined,
      majorName: undefined,
      courceId: undefined,
      courceName: undefined,
    });
  };
  onChangeMajorId = (newValue: any) => {
    this.setState({
      majorId: newValue !== undefined ? newValue.value : undefined,
      majorName: newValue !== undefined ? newValue.label : undefined,
      courceId: undefined,
      courceName: undefined,
    });
  };
  onChangeCourceId = (newValue: any) => {
    this.setState({
      courceId: newValue !== undefined ? newValue.value : undefined,
      courceName: newValue !== undefined ? newValue.label : undefined,
    });
  };

  // 登録画面の確認ボタン押す
  editConfirm = (data: FormData) => {
    this._page.current?.setState({ isPageLoading: true });
    // データ保存
    this.setState({
      mailAddress: data.mailAddress,
      userAccount: data.userAccount,
      disabledFlag: data.disabledFlag,
      browsePastFlag: data.browsePastFlag,
      superUpdateFlag: data.superUpdateFlag,
      sei: data.sei,
      mei: data.mei,
      seiKana: data.seiKana,
      meiKana: data.meiKana,
    });

    // 確認画面表示
    this.setState({
      showDivId: 2,
    });
    this._page.current?.setState({ isPageLoading: false });
  };

  // 確認画面の確認ボタン押す
  confirmConfirm = async () => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      // this.setState({ errorMsg: "" });

      // backend通信し、ユーザ登録
      const postData: UserSaveRequestBean = {
        userId: this.state.userId,
        universityCode: this.state.universityCode!,
        userAccount: this.state.userAccount!,
        mailAddress: this.state.mailAddress!,
        sei: this.state.sei!,
        mei: this.state.mei!,
        seiKana: this.state.seiKana!,
        meiKana: this.state.meiKana!,
        userTypeCode: this.state.userTypeCode!,
        disabledFlag: this.state.disabledFlag!,
        browsePastFlag: this.state.browsePastFlag!,
        superUpdateFlag: this.state.superUpdateFlag!,
        facultyId: this.state.facultyId,
        departmentId: this.state.departmentId,
        majorId: this.state.majorId,
        courceId: this.state.courceId,
      };
      const result = await http<ResultBean, UserSaveRequestBean>({
        path: "/User/save",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        // 保存成功
        // 完了画面表示
        this.setState({ showDivId: 3 });
      } else {
        // 失敗
        message.error(Messages["ERR-020"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      // エラー
      console.log(error);
      message.error(Messages["ERR-020"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 確認画面の戻るボタン押す
  confirmBack = () => {
    this.setState({ showDivId: 1 });
  };

  backToList = () => {
    const { location, navigation } = this.props;
    if (location.state) {
      navigation("/UserList", { state: location.state });
    } else {
      navigation("/UserList");
    }
  };
  backToRegistNew = () => {
    this.setState({
      showDivId: 1,
      showFaculty: 0,
      userTypeSelectDiv: undefined,
      userId: undefined,
      universityCode: undefined,
      userAccount: undefined,
      mailAddress: undefined,
      sei: undefined,
      mei: undefined,
      seiKana: undefined,
      meiKana: undefined,
      userTypeCode: undefined,
      userTypeName: undefined,
      disabledFlag: undefined,
      browsePastFlag: undefined,
      superUpdateFlag: undefined,
      facultyId: undefined,
      facultyName: undefined,
      departmentId: undefined,
      departmentName: undefined,
      majorId: undefined,
      majorName: undefined,
      courceId: undefined,
      courceName: undefined,
    });
    if (this.context.user.userTypeCode === userTypeCodeODK_SU) {
      this.setState({
        userTypeSelectDiv: "1",
        userTypeCode: userTypeCodeUNIV_SU,
        userTypeName: userTypeNameUNIV_SU,
      });
    } else {
      this.setState({
        universityCode: this.context.user.universityCode,
        userTypeSelectDiv: "0",
      });
    }
    this._form.current.resetFields();
  };

  // validator
  validatorIsNotEmail = async (_: any, value: string): Promise<void> => {
    const pattern = {
      email:
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    };
    if (
      value !== undefined &&
      value != null &&
      value.length <= 320 &&
      value.match(pattern.email)
    ) {
      return Promise.reject(new Error(Messages["ERR-024"]));
    }
    return Promise.resolve();
  };
  validatorCheckUserAccountExist = async (
    _: any,
    value: string
  ): Promise<void> => {
    try {
      if (value === undefined || value == null || value === "")
        return Promise.resolve();
      // backend通信し、ユーザアカウントの存在チェックを行う
      const postData: UserCheckAccountRequestBean = {
        userId: this.state.userId,
        userAccount: value,
        universityCode: this.state.universityCode,
      };
      const result = await http<ResultBean, UserCheckAccountRequestBean>({
        path: "/User/check/account",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        // 存在する
        return Promise.reject(new Error(Messages["ERR-025"]));
      } else {
        return Promise.resolve();
      }
    } catch (error) {
      // エラー
      console.log(error);
      message.error(Messages["ERR-020"]);
    }
  };
  validatorCheckMailAddressExist = async (
    _: any,
    value: string
  ): Promise<void> => {
    try {
      if (value === undefined || value == null || value === "")
        return Promise.resolve();
      // backend通信し、ユーザアカウントの存在チェックを行う
      const postData: UserCheckMailAddressRequestBean = {
        userId: this.state.userId,
        mailAddress: value,
      };
      const result = await http<ResultBean, UserCheckMailAddressRequestBean>({
        path: "/User/check/mailaddress",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body?.result === "1") {
        // 存在する
        return Promise.reject(new Error(Messages["ERR-003"]));
      } else {
        return Promise.resolve();
      }
    } catch (error) {
      // エラー
      console.log(error);
      message.error(Messages["ERR-020"]);
    }
  };

  render(): React.ReactNode {
    return (
      <Page title="ユーザ登録/修正" ref={this._page}>
        {/* <div
          style={{
            margin: "20px",
            display: this.state.errorMsg !== "" ? "block" : "none",
          }}
        >
          <Alert
            type="error"
            description={this.state.errorMsg}
            message="エラー"
            closable
          />
        </div> */}

        <div
          style={{
            margin: "20px",
            display: this.state.showDivId === 1 ? "block" : "none",
          }}
        >
          <Form
            name="userEdit"
            layout="horizontal"
            colon={false}
            labelCol={{ span: 6 }}
            labelAlign="left"
            labelWrap={true}
            onFinish={this.editConfirm}
            className="user-form"
            ref={this._form}
          >
            <Row>
              {this.context.user.userTypeCode === userTypeCodeODK_SU && (
                <Col span={12}>
                  <Form.Item
                    label="大学"
                    name="universityCode"
                    rules={[{ required: true }]}
                  >
                    <CommonMasterSelect
                      masterType={1}
                      allowClear={false}
                      width={200}
                      onChange={this.onChangeUniversityCode}
                    />
                  </Form.Item>
                </Col>
              )}
              <Col span={12}>
                <Form.Item
                  label="アカウント"
                  name="userAccount"
                  validateTrigger={["onChange", "onFocus", "onBlur"]}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      validateTrigger: ["onChange"],
                    },
                    { max: 30, validateTrigger: ["onChange"] },
                    {
                      validator: this.validatorIsNotEmail,
                      validateTrigger: ["onChange"],
                    },
                    {
                      validator: this.validatorCheckUserAccountExist,
                      validateTrigger: ["onFocus", "onBlur"],
                    },
                  ]}
                >
                  <Input style={{ width: 250 }} maxLength={30} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="メールアドレス"
                  name="mailAddress"
                  validateTrigger={["onChange", "onFocus", "onBlur"]}
                  rules={[
                    { required: true, validateTrigger: ["onChange"] },
                    { type: "email", validateTrigger: ["onChange"] },
                    // {
                    //   validator: this.validatorCheckMailAddressExist,
                    //   validateTrigger: ["onFocus", "onBlur"],
                    // },
                  ]}
                >
                  <Input style={{ width: 200 }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="ステータス"
                  name="disabledFlag"
                  rules={[{ required: true }]}
                >
                  <Select style={{ width: 100 }}>
                    <Option value="0">有効</Option>
                    <Option value="1">無効</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="姓（漢字）"
                  name="sei"
                  rules={[{ required: true, whitespace: true }, { max: 20 }]}
                >
                  <Input style={{ width: 200 }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="名（漢字）"
                  name="mei"
                  rules={[{ required: true, whitespace: true }, { max: 20 }]}
                >
                  <Input style={{ width: 200 }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="姓（カナ）"
                  name="seiKana"
                  rules={[{ required: true, whitespace: true }, { max: 20 }]}
                >
                  <Input style={{ width: 200 }} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="名（カナ）"
                  name="meiKana"
                  rules={[{ required: true, whitespace: true }, { max: 20 }]}
                >
                  <Input style={{ width: 200 }} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="過去データ閲覧"
                  name="browsePastFlag"
                  rules={[{ required: true }]}
                >
                  <Select style={{ width: 100 }}>
                    <Option value="1">閲覧可能</Option>
                    <Option value="0">閲覧不可</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="スーパー修正"
                  name="superUpdateFlag"
                  dependencies={["userTypeCode"]}
                  rules={[
                    { required: true },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          value &&
                          getFieldValue("userTypeCode") &&
                          value === "1" &&
                          (getFieldValue("userTypeCode").value ===
                            userTypeCodeUNIV_GRADER ||
                            getFieldValue("userTypeCode") ===
                              userTypeCodeUNIV_GRADER)
                        ) {
                          return Promise.reject(new Error(Messages["ERR-092"]));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Select style={{ width: 100 }}>
                    <Option value="1">可能</Option>
                    <Option value="0">不可</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  label="ユーザ種別"
                  name="userTypeCode"
                  dependencies={["superUpdateFlag"]}
                  rules={[
                    { required: true },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          value &&
                          getFieldValue("superUpdateFlag") &&
                          value.value === userTypeCodeUNIV_GRADER &&
                          getFieldValue("superUpdateFlag") === "1"
                        ) {
                          return Promise.reject(new Error(Messages["ERR-092"]));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <CommonMasterSelect
                    masterType={6}
                    allowClear={false}
                    width={200}
                    ucode={this.state.userTypeSelectDiv}
                    onChange={this.onChangeUserTypeCode}
                  />
                </Form.Item>
              </Col>
            </Row>
            {this.state.showFaculty === 1 && (
              <Row>
                <Col span={12}>
                  <Form.Item
                    label="所属学部"
                    name="facultyId"
                    rules={[{ required: true }]}
                  >
                    <CommonMasterSelect
                      allowClear={false}
                      ucode={this.state.universityCode}
                      masterType={2}
                      width={160}
                      onChange={this.onChangeFacultyId}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="所属学科" name="departmentId">
                    <CommonMasterSelect
                      allowClear={true}
                      ucode={this.state.universityCode}
                      fid={this.state.facultyId}
                      masterType={3}
                      width={160}
                      onChange={this.onChangeDepartmentId}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            {this.state.showFaculty === 1 && (
              <Row>
                <Col span={12}>
                  <Form.Item label="所属専攻" name="majorId">
                    <CommonMasterSelect
                      allowClear={true}
                      ucode={this.state.universityCode}
                      fid={this.state.departmentId}
                      masterType={4}
                      width={160}
                      onChange={this.onChangeMajorId}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="所属コース" name="courceId">
                    <CommonMasterSelect
                      allowClear={true}
                      ucode={this.state.universityCode}
                      fid={this.state.majorId}
                      masterType={5}
                      width={160}
                      onChange={this.onChangeCourceId}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row style={{ marginTop: "10px", marginLeft: "10px" }}>
              <Col span={5}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    確認
                  </Button>
                </Form.Item>
              </Col>
              {this.props.params.userId !== undefined && (
                <Col span={5}>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.backToList}
                  >
                    戻る
                  </Button>
                </Col>
              )}
            </Row>
          </Form>
        </div>
        <div
          style={{
            margin: "20px",
            display: this.state.showDivId === 2 ? "block" : "none",
          }}
        >
          <div>下記内容でユーザ登録を行います。よろしいですか？</div>
          <div>
            <Row style={{ marginTop: 20 }}>
              {this.context.user.userTypeCode === userTypeCodeODK_SU && (
                <Col span={4}>
                  <span style={{ fontWeight: "bold" }}>大学</span>
                </Col>
              )}
              {this.context.user.userTypeCode === userTypeCodeODK_SU && (
                <Col span={6}>
                  <span className="ant-form-text">
                    {this.state.universityCode}
                  </span>
                </Col>
              )}
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>アカウント</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">{this.state.userAccount}</span>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>メールアドレス</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">{this.state.mailAddress}</span>
              </Col>
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>ステータス</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">
                  {this.state.disabledFlag === "0" ? "有効" : "無効"}
                </span>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>姓名</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">
                  {this.state.sei} {this.state.mei}
                </span>
              </Col>
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>姓名（カナ）</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">
                  {this.state.seiKana} {this.state.meiKana}
                </span>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>過去データ閲覧</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">
                  {this.state.browsePastFlag === "1" ? "閲覧可能" : "閲覧不可"}
                </span>
              </Col>
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>スーパー修正</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">
                  {this.state.superUpdateFlag === "1" ? "可能" : "不可"}
                </span>
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col span={4}>
                <span style={{ fontWeight: "bold" }}>ユーザ種別</span>
              </Col>
              <Col span={6}>
                <span className="ant-form-text">{this.state.userTypeName}</span>
              </Col>
            </Row>
            {this.state.showFaculty === 1 && (
              <Row style={{ marginTop: 10 }}>
                <Col span={4}>
                  <span style={{ fontWeight: "bold" }}>所属学部</span>
                </Col>
                <Col span={6}>
                  <span className="ant-form-text">
                    {this.state.facultyName}
                  </span>
                </Col>
                <Col span={4}>
                  <span style={{ fontWeight: "bold" }}>所属学科</span>
                </Col>
                <Col span={6}>
                  <span className="ant-form-text">
                    {this.state.departmentName}
                  </span>
                </Col>
              </Row>
            )}
            {this.state.showFaculty === 1 && (
              <Row style={{ marginTop: 10 }}>
                <Col span={4}>
                  <span style={{ fontWeight: "bold" }}>所属専攻</span>
                </Col>
                <Col span={6}>
                  <span className="ant-form-text">{this.state.majorName}</span>
                </Col>
                <Col span={4}>
                  <span style={{ fontWeight: "bold" }}>所属コース</span>
                </Col>
                <Col span={6}>
                  <span className="ant-form-text">{this.state.courceName}</span>
                </Col>
              </Row>
            )}
            <Row style={{ marginTop: "20px", marginLeft: "10px" }}>
              <Col span={5}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.confirmConfirm}
                >
                  登録
                </Button>
              </Col>
              <Col span={5}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.confirmBack}
                >
                  戻る
                </Button>
              </Col>
            </Row>
          </div>
        </div>
        <div
          style={{
            margin: "20px",
            display: this.state.showDivId === 3 ? "block" : "none",
          }}
        >
          <div>ユーザ登録・修正は完了しました。</div>
          <div style={{ margin: "20px" }}>
            <Row style={{ marginTop: "10px", marginLeft: "10px" }}>
              <Col span={5}>
                {this.props.params.userId !== undefined ? (
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.backToList}
                  >
                    ユーザ一覧へ
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={this.backToRegistNew}
                  >
                    ユーザ登録へ
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </Page>
    );
  }
}

export default withRouterDom(UserRegister);
